module.exports = __webpack_public_path__ + "media/images/menu/corona_borealis-34508ad0be74a9a0afa652444f18b332.jpg";